import type { SvgIconProps } from '@mui/material';
import { SvgIcon } from '@mui/material';

export const LocomotiveIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        id="Vector 89"
        d="M1.5 15.5L1 15.5L1 7.71L1 2.11L1 1C1 1 7.57 1 8.14 1C8.71 1 7.28 2.11 7.28 2.11L1 2.11M7.28 2.11L7.28 7.71M15 4.35L15 5.47L15 7.71L11.85 7.71L11.57 7.71L7.28 7.71L1 7.71M15 7.71C15 7.71 14.14 7.71 15.85 7.71C17.57 7.71 19 9.12 19 11.08C19 13.04 18.14 13.6 18.14 13.6L19 15.5L17.5 15.5M15 4.35C15 4.35 15.85 3.52 15.85 3.23C15.85 2.96 15.28 2.4 15 2.4C14.71 2.4 12.14 2.4 11.85 2.4C11.57 2.4 11 2.96 11 3.23C11 3.52 11.85 4.35 11.85 4.35L15 4.35ZM11.85 7.71L11.85 5.47L11.85 4.35M15 5.47L11.85 5.47"
        stroke="currentColor"
        fill="none"
        strokeOpacity="1.000000"
        strokeWidth="1.000000"
      />
      <path
        id="Vector 90"
        d="M6 12C7.75 12 9.5 13.45 9.5 15.5C9.5 17.54 7.75 19 6 19C4.24 19 2.5 17.43 2.5 15.5C2.5 13.56 4.24 12 6 12ZM9.5 15.5C9.5 13.45 11.14 12 13 12C14.85 12 16.5 13.56 16.5 15.5C16.5 17.43 14.85 19 13 19C11.14 19 9.5 17.54 9.5 15.5M6 13.5C4.97 13.5 4 14.37 4 15.5C4 16.62 4.97 17.5 6 17.5C7.02 17.5 8.04 16.62 8.04 15.5C8.04 14.37 7.02 13.5 6 13.5ZM11 15.5C11 14.37 11.97 13.5 13 13.5C14.02 13.5 15 14.37 15 15.5C15 16.62 14.02 17.54 13 17.54C11.97 17.54 11 16.62 11 15.5Z"
        stroke="currentColor"
        fill="none"
        strokeOpacity="1.000000"
        strokeWidth="1.000000"
      />
      <path
        id="Vector 92"
        d="M6 15.5L13 15.5"
        stroke="currentColor"
        fill="none"
        strokeOpacity="1.000000"
        strokeWidth="1.000000"
        strokeLinecap="round"
      />
    </SvgIcon>
  );
};
